/**
 * Device capability detection (no user-agent sniffing).
 */

export const IS_TOUCH_DEVICE = (() => {
  if (typeof window === "undefined") return false;

  // `pointer: coarse` is the most reliable signal for touch-primary devices
  if (window.matchMedia?.("(pointer: coarse)").matches) return true;

  // Fallback: check for touch capabilities
  if (navigator.maxTouchPoints > 0) return true;
  if ("ontouchstart" in window) return true;

  return false;
})();

export const HAS_FULLSCREEN_API = (() => {
  if (typeof document === "undefined") return false;
  return typeof document.documentElement.requestFullscreen === "function";
})();
